import logo from './images/logo1.png';
import burgerElement from './images/burgerElement.png';
import emptyUser from './images/emptyUser.png';
import plane from './images/plane.png';
import bell from './images/bell.png';
import './Header.scss';
import cn from 'classnames'
import { LoginForm } from '../Login/LoginForm';
import { ForgotPasswordForm1 } from '../ForgotPaswordForms/ForgotPasswordForm1';
import { ForgotPasswordForm2 } from '../ForgotPaswordForms/ForgotPasswordForm2';
import { ForgotPasswordForm3 } from '../ForgotPaswordForms/ForgotPasswordForm3';
import { CompanyForm } from '../Registration/CompanyForm/CompanyForm'
import { UserForm } from '../Registration/UserForm/UserForm'
import { EmailConfirmationForm } from '../Registration/EmailConfirmationForm/EmailConfirmationForm'
import { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { useUser } from '../../context/UserContext';
import { useCart } from '../../context/CartContext';
import {Link, useLocation, useNavigate} from 'react-router-dom'
import { SearchBar } from '../Search/SearchBar';

// Define modal types
const MODAL_TYPES = {
  LOGIN: 'login',
  REGISTER_COMPANY: 'registerCompany',
  REGISTER_USER: 'registerUser',
  EMAIL_CONFIRMATION: 'emailConfirmation',
  FORGOT_PASSWORD_1: 'forgotPassword1',
  FORGOT_PASSWORD_2: 'forgotPassword2',
  FORGOT_PASSWORD_3: 'forgotPassword3',
};

export const Header = ({ 
  isBlack = true, 
  isRegisterFormVisible, 
  setIsRegisterFormVisible // Keep this prop to allow external triggering
}) => {
  const [isLoginFormVisible, setIsLoginFormVisible] = useState(false);
  const [isUserFormVisible, setIsUserFormVisible] = useState(false);
  const [isEmailConfirmationFormVisible, setIsEmailConfirmationFormVisible] = useState(false);
  const [isForgotPasswordForm1Visible, setIsForgotPasswordForm1Visible] = useState(false);
  const [isForgotPasswordForm2Visible, setIsForgotPasswordForm2Visible] = useState(false);
  const [isForgotPasswordForm3Visible, setIsForgotPasswordForm3Visible] = useState(false);
  const [activeModal, setActiveModal] = useState(null); 
  const { user } = useUser();
  const { getCartTotal } = useCart();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    window.location.href = '/';
  };

  const handleSearchResults = ({ error }) => {
    if (error) {
      console.error('Search error:', error);
    }
  };

  const handleProductClick = (product) => {
    if (!user) {
      localStorage.setItem('redirectProductId', product.id);
      toggleLoginForm();
    }
  };

  const openModal = (modalType) => {
    setActiveModal(modalType);
    if (isRegisterFormVisible && modalType !== MODAL_TYPES.REGISTER_COMPANY) {
      setIsRegisterFormVisible(false);
    }
  };

  const closeModal = () => {
    setActiveModal(null);
    if (isRegisterFormVisible) {
      setIsRegisterFormVisible(false);
    }
  };

  useEffect(() => {
    if (isRegisterFormVisible && activeModal !== MODAL_TYPES.REGISTER_COMPANY) {
      openModal(MODAL_TYPES.REGISTER_COMPANY);
    }
  }, [isRegisterFormVisible]);

  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [activeModal]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef]);

  const toggleLoginForm = () => {
    openModal(MODAL_TYPES.LOGIN);
  };

  return (
    <>
      <header className={cn('Header', {'Header__white': !isBlack})}>
        <div className="Header__container">
          <Link to={'/'}>
            <img 
              src={logo} 
              alt='Logo' 
              className={cn('Header__logo', {'Header__logo__white': !isBlack})} 
            />
          </Link>
          <div className="Header__search-bar">
            <SearchBar onResultsUpdate={handleSearchResults} />
          </div>

          {!user ? (
            <div className='Header__login'>
              <span
                onClick={toggleLoginForm}
                className={cn({ 'Header__login-link': true, 'Header__login-link__white': !isBlack })}
              >
                Login
              </span>
              <span 
                onClick={() => openModal(MODAL_TYPES.REGISTER_COMPANY)}
                className={cn({ 'Header__signup-link': true, 'Header__signup-link__white': !isBlack })}
              >
                Sign Up
              </span>
            </div>
          ) : (
            <div className='Header__user'>
              <Link to='/basket' className={cn({ 'Header__cart': true, 'Header__cart__white': !isBlack })}>
                <span className={cn({ 'Header__cart-total': true, 'Header__cart-total__white': !isBlack })}>
                  €{getCartTotal()}
                </span>
              </Link>
              <div className='Header__messages'>
                <Link to='/messages'>
                  <img src={plane} alt='Messages' className={cn({ 'Header__messages-icon': true, 'Header__messages-icon__white': !isBlack })} />
                </Link>
              </div>
              <div className='Header__notifications'>
                <Link to='/notifications'>
                  <img src={bell} alt='Notifications' className={cn({ 'Header__notifications-icon': true, 'Header__notifications-icon__white': !isBlack })} />
                </Link>
              </div>
              <div className='Header__menu' onClick={() => setIsMenuOpen(!isMenuOpen)}>
                <img src={burgerElement} alt='burger' className={cn({ 'Header__menu-line': true, 'Header__menu-line__white': !isBlack })} />
                <img src={burgerElement} alt='burger' className={cn({ 'Header__menu-line': true, 'Header__menu-line__white': !isBlack })} />
                <img src={burgerElement} alt='burger' className={cn({ 'Header__menu-line': true, 'Header__menu-line__white': !isBlack })} />
              </div>
              <Link to='profile/'>
                <img
                  className='Header__user__avatar'
                  src={user?.user_photo || emptyUser}
                  alt='User avatar'
                />
              </Link>
            </div>
          )}
            
          {isMenuOpen && user && (
            <div className="Header__dropdown" ref={menuRef}>
              <ul>
                <li onClick={() => setIsMenuOpen(false)}><Link to="/orders">My orders</Link></li>
                <li onClick={() => setIsMenuOpen(false)}><Link to="/basket">Basket</Link></li>
                <li onClick={() => setIsMenuOpen(false)}><Link to="/lead-list">Lead List</Link></li>
                <li onClick={logout}><Link to="/">Log out</Link></li> 
              </ul>
            </div>
          )}
        </div>
      </header>

      {activeModal === MODAL_TYPES.LOGIN && (
        <div className="Overlay">
          <div className="Overlay__content" onClick={(e) => e.stopPropagation()}>
            <LoginForm
              setIsLoginFormVisible={() => closeModal()} // Close this modal
              setIsRegisterFormVisible={() => openModal(MODAL_TYPES.REGISTER_COMPANY)} // Open company form
              setIsForgotPasswordForm1Visible={() => openModal(MODAL_TYPES.FORGOT_PASSWORD_1)} // Open forgot password 1
            />
          </div>
        </div>
      )}

      {activeModal === MODAL_TYPES.REGISTER_COMPANY && (
        <div className="Overlay">
          <div className="Overlay__content" onClick={(e) => e.stopPropagation()}>
            <CompanyForm
              setIsRegisterFormVisible={() => closeModal()} // Close this modal
              setIsUserFormVisible={() => openModal(MODAL_TYPES.REGISTER_USER)} // Open user form
              setIsLoginFormVisible={() => openModal(MODAL_TYPES.LOGIN)} // Open login form
            />
          </div>
        </div>
      )}

      {activeModal === MODAL_TYPES.REGISTER_USER && (
        <div className="Overlay">
          <div className="Overlay__content" onClick={(e) => e.stopPropagation()}>
            <UserForm
              setIsUserFormVisible={() => closeModal()}
              setIsEmailConfirmationFormVisible={() => openModal(MODAL_TYPES.EMAIL_CONFIRMATION)}
              setIsRegisterFormVisible={() => openModal(MODAL_TYPES.REGISTER_COMPANY)}
            />
          </div>
        </div>
      )}

      {activeModal === MODAL_TYPES.EMAIL_CONFIRMATION && (
        <div className="Overlay">
          <div className="Overlay__content" onClick={(e) => e.stopPropagation()}>
            <EmailConfirmationForm
              setIsEmailConfirmationFormVisible={() => closeModal()}
            />
          </div>
        </div>
      )}

      {activeModal === MODAL_TYPES.FORGOT_PASSWORD_1 && (
        <div className="Overlay">
          <div className="Overlay__content" onClick={(e) => e.stopPropagation()}>
            <ForgotPasswordForm1
              setIsForgotPasswordForm1Visible={() => closeModal()}
              setIsForgotPasswordForm2Visible={() => openModal(MODAL_TYPES.FORGOT_PASSWORD_2)}
              setIsLoginFormVisible={() => openModal(MODAL_TYPES.LOGIN)}
            />
          </div>
        </div>
      )}

      {activeModal === MODAL_TYPES.FORGOT_PASSWORD_2 && (
        <div className="Overlay">
          <div className="Overlay__content" onClick={(e) => e.stopPropagation()}>
            <ForgotPasswordForm2
              setIsForgotPasswordForm2Visible={() => closeModal()}
              setIsForgotPasswordForm3Visible={() => openModal(MODAL_TYPES.FORGOT_PASSWORD_3)}
              setIsForgotPasswordForm1Visible={() => openModal(MODAL_TYPES.FORGOT_PASSWORD_1)}
            />
          </div>
        </div>
      )}

      {activeModal === MODAL_TYPES.FORGOT_PASSWORD_3 && (
        <div className="Overlay">
          <div className="Overlay__content" onClick={(e) => e.stopPropagation()}>
            <ForgotPasswordForm3
              setIsForgotPasswordForm3Visible={() => closeModal()}
              setIsLoginFormVisible={() => openModal(MODAL_TYPES.LOGIN)}
            />
          </div>
        </div>
      )}
    </>
  );
};